export default (node) => {
  const heroSection = node;
  let zoomInTriggered = false;

  const triggerZoom = (heroSection, zoomInTriggered) => {
    if (
      heroSection.getBoundingClientRect().y < window.innerHeight * 0.75 &&
      !zoomInTriggered
    ) {
      heroSection.classList.add('triggered');
      return true;
    } else {
      return false;
    }
  };

  const init = () => {
    if (heroSection.classList.contains('zoom-in')) {
      zoomInTriggered = triggerZoom(heroSection, zoomInTriggered);
      window.addEventListener('scroll', () => {
        zoomInTriggered = triggerZoom(heroSection, zoomInTriggered);
      });
    }
  };

  init();
};
